export const Asset = {
    id: "",
    uid: "",
    tag: "",
    name: "",
    description: "",
    type: "",
    waste: 0,
    waste_type: "gl",
    waste_status: "",
    waste_name: "",
    active: false,
    group_id: "",
    group_name: "",
    zone_id: "",
    zone_name: "",
    island: 0,
    islan_id: 0,
    island_name: "",
    created_at: Date,
    updated_at: Date,
    installed_at: Date,
    ended_at: Date,
    manufactured_at: Date,
    manufactured: "",
    idx: "",
    container_type: "",
    download_type: "",
    panel: "",
    has_alerts: false,
    has_device: true,
    has_route: false,
    height: 0,
    volume: 0,
    offset: 0,
    c_factor: 0,
    d_factor: 0,
    threshold: 0,
    address: "",
    number: 0,
    lat: 0,
    lng: 0,
    province: "",
    country: "",
    municipality: "",
    codpost: "",
    full_address: "",
    image: "",
    uuids: [],
    devices_uuids: [],
    filling: 0,
    routes_name: "",
    route_name: "",
    routes_id: "",
    measured_at: "",
    last_route_at: "",
}

export const Waste = {
    id: "",
    model: "",
    name: "",
    uid: "",
    height: "",
    volume: "",
    offset: "",
    c_factor: "",
    d_factor: "",
    container_type: "",
    download_type: "",
    panel: "",
    waste_type: "",
    manufactured_at: ""
}


export const AssetChoiceModel = {
    id: "",
    name: "",
    type: "",
    full_address: "",
    description: "",
    image: "",
    active: ""
}